import axios, { AxiosError } from 'axios';
import {
  ConsultationRequest,
  ConsultationRequestListParams,
  PaginatedResponse,
} from '@tassomutuo-backoffice/types';
import { axiosApiInstancePrivate } from '../index';

const BASE_PATH = '/v1/backoffice/consultation-requests';

function handleAxiosError(err: unknown): never {
  const error = err as Error | AxiosError;
  if (axios.isAxiosError(error)) {
    throw error?.response?.data ?? error;
  }
  throw err;
}

export const listConsultationRequests = async (
  params: ConsultationRequestListParams
): Promise<PaginatedResponse<ConsultationRequest>> => {
  try {
    const { data } = await axiosApiInstancePrivate.get<
      PaginatedResponse<ConsultationRequest>
    >(BASE_PATH, { params });
    return data;
  } catch (err) {
    handleAxiosError(err);
  }
};

export const getConsultationRequest = async (
  id: string
): Promise<ConsultationRequest> => {
  try {
    const { data } = await axiosApiInstancePrivate.get<ConsultationRequest>(
      `${BASE_PATH}/${id}`
    );
    return data;
  } catch (err) {
    handleAxiosError(err);
  }
};
